import React, {useEffect, useState} from "react";
import "./style.less";
import MyAccountNav from "../MyAccountNav";
import {
    ConnectPayments,
    ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import {useTranslation} from "react-i18next";
import {stripeServices} from "../../../../../../services/stripeServices";
import {loadConnectAndInitialize} from "@stripe/connect-js";
import Loading from "../../../../../../components/Loading";


const Payments = (props) => {
    const {t} = useTranslation();

    const [loading, setLoading] = useState(false);
    const [stripeConnectInstance, setStripeConnectInstance] = useState();

    const handleGetSripeSession = async () => {
        setLoading(true)
        setStripeConnectInstance(null)
        stripeServices.getAccountSession("payments")
            .then(({account_id, client_secret}) => {
                console.log("got account session", account_id, client_secret);
                setStripeConnectInstance(
                    loadConnectAndInitialize({
                        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
                        fetchClientSecret: async () => {
                            return client_secret
                        },
                        fonts: [{
                            family: "Inter",
                            src: "url(https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap)",
                        }],
                        locale: localStorage.getItem('i18nextLng'),
                        appearance: {
                            overlays: "dialog",
                            variables: {
                                colorPrimary: "#dcefec",
                                fontSizeBase: "16px",
                                fontFamily: "Inter, sans-serif",
                            },
                        },
                    })
                );
            }).catch((e) => {
            console.error("Error on useStripeConnect:", e);
            setStripeConnectInstance(null);
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        handleGetSripeSession()
    }, [localStorage.getItem("i18nextLng")]);

    return (
        <div className={"payments__container"}>
            <MyAccountNav pages={props.pages}/>
            <div className="payments">
                <h5>{t("my_account.payments")}</h5>
                {loading && <Loading relative />}
                {stripeConnectInstance && <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                    <ConnectPayments />
                </ConnectComponentsProvider>}
            </div>
        </div>
    );
}

export default Payments;
